export function getTime(start: number): number {
  return Math.round((window.performance.now() - start) * 10000) / 10000;
}
